import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

export default function SessionInactivityDialog({ secondsRemaining, onContinue, onLogout }) {
  const open = secondsRemaining !== null

  return (
    <Dialog open={open} disableEscapeKeyDown onClose={() => {}} aria-labelledby="session-inactivity-title" maxWidth="xs" fullWidth>
      <DialogTitle id="session-inactivity-title">Still using Sparkle?</DialogTitle>
      <DialogContent>
        <Typography>
          You&apos;ve been inactive. Your session will end in {secondsRemaining ?? 0} seconds.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">Log out</Button>
        <Button onClick={onContinue} variant="contained" autoFocus>Continue session</Button>
      </DialogActions>
    </Dialog>
  )
}
